import { Avatar, getProductColorShade } from '@george-labs.com/design-system';
import type { COLOR } from '@george-labs.com/design-system/types/utilsTS/color';
import type {
    AVATAR_VARIANT,
    AvatarProps,
} from '@george-labs.com/design-system/types/components/Image';

type CustomAvatarProps = {
    COLOR: COLOR;
    BACKGROUND_COLOR: COLOR;
    VARIANT: AVATAR_VARIANT;
};
export const CONTACTS_AVATAR: CustomAvatarProps = {
    COLOR: Avatar.COLOR.UI_BLUE,
    BACKGROUND_COLOR: Avatar.COLOR.UI_BLUE_WEAK,
    VARIANT: Avatar.VARIANT.BORDERLESS,
};
export const CURRENT_ACCOUNT_AVATAR: CustomAvatarProps = {
    COLOR: Avatar.COLOR.BERRY,
    BACKGROUND_COLOR: Avatar.COLOR.BERRY_WEAK,
    VARIANT: Avatar.VARIANT.BORDERLESS,
};
export const SAVING_AND_LOAN_ACCOUNTS_AVATAR: CustomAvatarProps = {
    COLOR: Avatar.COLOR.FOREST_STRONG,
    BACKGROUND_COLOR: Avatar.COLOR.FOREST_WEAK,
    VARIANT: Avatar.VARIANT.BORDERLESS,
};
export const TEMPLATES_AVATAR: CustomAvatarProps = {
    COLOR: Avatar.COLOR.UI_BLUE,
    BACKGROUND_COLOR: Avatar.COLOR.UI_BLUE_WEAK,
    VARIANT: Avatar.VARIANT.BORDERLESS,
};

export const CONTACTS_SECONDARY_AVATAR: CustomAvatarProps = {
    COLOR: Avatar.COLOR.UI_BLUE,
    BACKGROUND_COLOR: Avatar.COLOR.UI_BLUE_WEAK,
    VARIANT: Avatar.VARIANT.BORDERLESS,
};

export const getCustomAvatarProperties = (
    color?: COLOR | string,
): Pick<AvatarProps, 'color' | 'backgroundColor' | 'variant'> => {
    if (!color) {
        return {
            color: CONTACTS_AVATAR.COLOR,
            backgroundColor: CONTACTS_AVATAR.BACKGROUND_COLOR,
            variant: CONTACTS_AVATAR.VARIANT,
        };
    }

    const normalizedColor = color.toLowerCase() as COLOR;

    const strongColor = getProductColorShade(normalizedColor, 'strong');
    const weakColor = getProductColorShade(normalizedColor, 'weak');

    return {
        color: strongColor,
        backgroundColor: weakColor,
        variant: Avatar.VARIANT.BORDERLESS,
    };
};
